<div
    class="event-header-scoreboard"
    [class.image]="showParticipantImage()"
    [class.has-participant-statistics]="showParticipantStats"
    [class.empty]="empty">
    <a
        class="event-header-href-area"
        dsTouchClick
        [href]="eventUrl"
        [vnSpeculativeLink]="eventUrl"
        [msRemoveHref]="shouldRemoveHref"
        (click)="navigate($event)">
        @if (isEpcotEnabled) {
            <div class="grid-event-header-wrapper">
                <div class="event-timer-scoreboard-info">
                    <div class="event-timer-scoreboard-info-header">
                        <ms-event-info
                            [mediaEnabled]="media().enabled"
                            [disableBadges]="true"
                            [showEventTimerInfoSection]="true"
                            [showFixedFooterSection]="false"
                            [event]="event()"
                            (click)="eventClick($event)" />
                    </div>
                </div>
            </div>
        }
        <div class="event-info-wrapper">
            <ms-event-detail
                [event]="event()"
                [mediaEnabled]="media().enabled"
                [showEventTimerInfoSection]="true"
                [showParticipantImage]="showParticipantImage()"
                [showParticipantStats]="showParticipantStats"
                [showLogoColor]="true"
                [isAllMarketsLinkEnabled]="isEpcotEnabled"
                [showPromotionBadge]="true" />
            <ms-grid-scoreboard [event]="event()" [tracking]="tracking()" />
        </div>

        @if (isEpcotEnabled) {
            <ms-event-footer
                class="event-header-footer badges-wrapper"
                [event]="event()"
                [mediaEnabled]="media().enabled"
                [eventUrl]="eventUrl"
                [showEventTimerInfoSection]="false"
                [showFixedFooterSection]="true" />
        }
    </a>

    @if (media().enabled) {
        <ms-event-media [event]="event()" [media]="media()" [tracking]="tracking()" [compactScrobeoard]="true" (statsClicked)="statsClicked.emit()" />
    }

    <div class="event-toggle" (click)="toggle()">
        @if (state()?.collapsed) {
            <vn-icon name="theme-down" size="16" />
        } @else {
            <vn-icon class="toggle-icon-alignment" name="theme-up" size="16" />
        }
    </div>
</div>
